module.exports = __webpack_public_path__ + "static/presentor-a1ea0d23b6bbab0340c6dfa31e7225e6.jpg";